import { render, staticRenderFns } from "./account-details.vue?vue&type=template&id=78411b24&"
import script from "./account-details.vue?vue&type=script&lang=js&"
export * from "./account-details.vue?vue&type=script&lang=js&"
import style0 from "./account-details.vue?vue&type=style&index=0&lang=stylus&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports